import { render, staticRenderFns } from "./UserInfoCardV2026.vue?vue&type=template&id=34399906&scoped=true"
import script from "./UserInfoCardV2026.vue?vue&type=script&lang=js"
export * from "./UserInfoCardV2026.vue?vue&type=script&lang=js"
import style0 from "./UserInfoCardV2026.vue?vue&type=style&index=0&id=34399906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34399906",
  null
  
)

export default component.exports